import type { FC } from 'react'

import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from '@/components/interactives/Tooltip'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { cn } from '@/utils'

type GroupCollapseButtonProps = {
  onClick?: () => void
  collapsed?: boolean
  childrenCount: number
}

export const GroupCollapseButton: FC<GroupCollapseButtonProps> = ({
  onClick,
  childrenCount,
  collapsed = false,
}) => {
  return (
    <div className="relative">
      <Tooltip>
        <TooltipTrigger>
          <button
            className={cn(
              'flex-none flex items-center justify-center size-6 px-2 rounded-sm opacity-70 text-white hover:opacity-100! transition-opacity text-xs focus:outline-hidden',
            )}
            onClick={onClick}
          >
            <FontAwesomeIcon
              icon={faChevronDown}
              className={cn('transition-all', collapsed && 'rotate-90')}
            />
          </button>
        </TooltipTrigger>
        {collapsed && (
          <TooltipContent>{childrenCount} cues hidden</TooltipContent>
        )}
      </Tooltip>

      <span
        className={cn(
          'absolute flex pointer-events-none items-center justify-center -translate-y-1/2 translate-x-1/2 top-0 right-0 size-4 rounded-full bg-gray-500',
          'transition-opacity ease-in-out duration-300',
          collapsed ? 'opacity-100' : 'opacity-0',
        )}
      >
        <span className="text-xs text-gray-300">{childrenCount}</span>
      </span>
    </div>
  )
}
